import { render, staticRenderFns } from "./Property_owner_bookings.vue?vue&type=template&id=205b52a4"
import script from "./Property_owner_bookings.vue?vue&type=script&lang=js"
export * from "./Property_owner_bookings.vue?vue&type=script&lang=js"
import style0 from "./Property_owner_bookings.vue?vue&type=style&index=0&id=205b52a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports